const UNITS: { unit: Intl.RelativeTimeFormatUnit; ms: number }[] = [
  { unit: "year", ms: 365 * 24 * 60 * 60 * 1000 },
  { unit: "month", ms: 30 * 24 * 60 * 60 * 1000 },
  { unit: "week", ms: 7 * 24 * 60 * 60 * 1000 },
  { unit: "day", ms: 24 * 60 * 60 * 1000 },
  { unit: "hour", ms: 60 * 60 * 1000 },
  { unit: "minute", ms: 60 * 1000 },
]

/** «3 дня назад» / «3 days ago»; для < 1 минуты — «сейчас». Пустая строка при невалидной дате. */
export function formatRelativeTime(iso: string | null | undefined, locale: string, now: number = Date.now()): string {
  if (!iso) return ""
  const time = new Date(iso).getTime()
  if (!Number.isFinite(time)) return ""
  const diff = time - now
  const abs = Math.abs(diff)
  const rtf = new Intl.RelativeTimeFormat(locale === "ru" ? "ru-RU" : "en-US", { numeric: "auto" })
  for (const { unit, ms } of UNITS) {
    if (abs >= ms) return rtf.format(Math.round(diff / ms), unit)
  }
  return rtf.format(0, "second")
}

const LIST_AGE_MINUTE = 60 * 1000
const LIST_AGE_HOUR = 60 * LIST_AGE_MINUTE
const LIST_AGE_DAY = 24 * LIST_AGE_HOUR
const LIST_AGE_WEEK = 7 * LIST_AGE_DAY
const LIST_AGE_MONTH = 30 * LIST_AGE_DAY
const LIST_AGE_YEAR = 365 * LIST_AGE_DAY

const LIST_AGE_LABELS = {
  ru: { now: "сейчас", minute: "мин", hour: "ч", day: "д", week: "нед", month: "мес", year: "г" },
  en: { now: "now", minute: "m", hour: "h", day: "d", week: "w", month: "mo", year: "y" },
} as const

const LIST_AGE_STEPS = [
  { ms: LIST_AGE_YEAR, unit: "year" },
  { ms: LIST_AGE_MONTH, unit: "month" },
  { ms: LIST_AGE_WEEK, unit: "week" },
  { ms: LIST_AGE_DAY, unit: "day" },
  { ms: LIST_AGE_HOUR, unit: "hour" },
  { ms: LIST_AGE_MINUTE, unit: "minute" },
] as const

/** Короткий возраст строки списка: «9 мин» / «2 ч», en: «9m» / «2h». Пустая строка при невалидной дате. */
export function formatListAge(iso: string | null | undefined, locale: string, now: number = Date.now()): string {
  if (!iso) return ""
  const time = new Date(iso).getTime()
  if (!Number.isFinite(time)) return ""
  const labels = locale === "ru" ? LIST_AGE_LABELS.ru : LIST_AGE_LABELS.en
  const abs = Math.abs(time - now)
  if (abs < LIST_AGE_MINUTE) return labels.now
  const step = LIST_AGE_STEPS.find(({ ms }) => abs >= ms)
  if (!step) return labels.now
  const amount = Math.max(1, Math.floor(abs / step.ms))
  const unit = labels[step.unit]
  return locale === "ru" ? `${amount} ${unit}` : `${amount}${unit}`
}
